export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete.indexOf('intervenants') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'repartition') {
      return i18n.t('ajoutEditContrat.bailleur.quotePart');
    }
    return propriete;
  }
  if (propriete === 'natureId') return i18n.t('ajoutEditContrat.messages.errors.champs.natureId');
  if (propriete === 'datePreavis') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.datePreavis');
  }
  if (propriete === 'dateFinEcheance') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.dateFinEcheance');
  }
  if (propriete === 'dateDebutEcheance') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.dateDebutEcheance');
  }
  if (propriete === 'dateDebutSignature') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.dateDebutSignature');
  }
  if (propriete === 'quantitePeriodicite') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.quantitePeriodicite');
  }
  if (propriete === 'dateFinSignature') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.dateFinSignature');
  }
  if (propriete === 'code') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.code');
  }
  if (propriete === 'loyerAnnuelTva') {
    return i18n.t('ajoutEditContrat.informationFinanciere.loyerAnnuelTva');
  }
  if (propriete === 'loyerAnnuelTtc') {
    return i18n.t('ajoutEditContrat.informationFinanciere.montantTtc');
  }
  if (propriete === 'loyerAnnuelHt') {
    return i18n.t('ajoutEditContrat.informationFinanciere.montantHt');
  }
  if (propriete === 'contrepartie') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.contrepartie');
  }
  if (propriete === 'commentaire') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.commentaire');
  }
  if (propriete.indexOf('echeancier[') === 0 && propriete.indexOf('].montantHt') !== -1) {
    return i18n.t('ajoutEditContrat.messages.errors.champs.montantHtEcheance');
  }
  if (propriete.indexOf('echeancier[') === 0 && propriete.indexOf('].Commentaire') !== -1) {
    return i18n.t('ajoutEditContrat.messages.errors.champs.commentaire');
  }
  if (propriete === 'dateCloture') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.dateCloture');
  }
  if (propriete === 'dateComptable') {
    return i18n.t('listeConstatationCharge.error.dateComptable');
  }
  if (propriete === 'motifNonRenouvellement') {
    return i18n.t('ajoutEditContrat.messages.errors.champs.motifNonRenouvellement');
  }
  return propriete;
}
